import React, { useEffect } from "react";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { MACHINE_SETUP, ADD_MACHINE } from "../apiEndpoints";
import AddMachineForm from "../forms/AddMachineForm";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import usePostData from "../../../CustomHooks/useAxios/usePostData";
import MainPageLayout from "../../../layout/MainPageLayout";

const AddMachinePage = () => {
  const { data, isLoaded, error, getData } = useGetData();
  const {
    executePost,
    loading,
    formError,
    successResponse,
    setFormError,
  } = usePostData();

  useEffect(() => {
    getData(MACHINE_SETUP);
  }, []);

  const sendData = async (formValue, reset) => {
    // API calling
    executePost(formValue, ADD_MACHINE, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Add Machine" }}>
      {isLoaded && !error ? (
        <AddMachineForm
          machineSetup={data}
          sendData={sendData}
          loading={loading}
          successResponse={successResponse}
        />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
      {formError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(formError)}
          closeAction={() => setFormError("")}
        />
      )}
    </MainPageLayout>
  );
};

export default AddMachinePage;
